var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _g, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNaturalLightExposure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 147,
    viewBox: "0 0 244 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107 147C78.2812 147 55 123.719 55 95C55 66.2812 78.2812 43 107 43C135.719 43 159 66.2812 159 95C159 123.719 135.719 147 107 147Z",
    fill: "#E7F7FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157 118C130.49 118 109 96.5097 109 70C109 43.4903 130.49 22 157 22C183.51 22 205 43.4903 205 70C205 96.5097 183.51 118 157 118Z",
    fill: "#E7F7FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146 146C121.699 146 102 126.301 102 102C102 77.6995 121.699 58 146 58C170.301 58 190 77.6995 190 102C190 126.301 170.301 146 146 146Z",
    fill: "#E7F7FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128 96C101.49 96 80 74.5097 80 48C80 21.4903 101.49 0 128 0C154.51 0 176 21.4903 176 48C176 74.5097 154.51 96 128 96Z",
    fill: "#E7F7FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92 99C67.6995 99 48 79.3005 48 55C48 30.6995 67.6995 11 92 11C116.301 11 136 30.6995 136 55C136 79.3005 116.301 99 92 99Z",
    fill: "#E7F7FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 236 71)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 45 139)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 10 70)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 48 6)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 190 8)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 244 140)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 77,
    r: 52,
    fill: "#D56D37"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11322_9759",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 25,
    width: 104,
    height: 104
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 77,
    r: 52,
    fill: "#D56D37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11322_9759)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 73,
    r: 48,
    fill: "#EEAA3C"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82 36C85.1752 36 87.9663 37.6443 89.5684 40.1277C90.0329 40.0438 90.5113 40 91 40C94.5002 40 97.4754 42.2478 98.5607 45.3787C99.3297 45.1328 100.149 45 101 45C105.418 45 109 48.5817 109 53C109 57.4183 105.418 61 101 61H72C67.5817 61 64 57.4183 64 53C64 48.5817 67.5817 45 72 45C72.3387 45 72.6725 45.0211 73.0002 45.0619L73 45C73 40.0294 77.0294 36 82 36Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166 52C162.825 52 160.034 53.6443 158.432 56.1277C157.967 56.0438 157.489 56 157 56C153.5 56 150.525 58.2478 149.439 61.3787C148.67 61.1328 147.851 61 147 61C142.582 61 139 64.5817 139 69C139 73.4183 142.582 77 147 77H176C180.418 77 184 73.4183 184 69C184 64.5817 180.418 61 176 61C175.661 61 175.327 61.0211 175 61.0619L175 61C175 56.0294 170.971 52 166 52Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M217.5 28.5L239 20",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M213 110.5L230 114.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30.5L2.5 22.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 112.5L10.5 118",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturalLightExposure);
export default __webpack_public_path__ + "static/media/natural-light-exposure.3e8e92b66c9fc2b47627f4aeb891e147.svg";
export { ForwardRef as ReactComponent };